export default {
  handleResize() {
    this.state.width = window.innerWidth;
    this.state.height = window.innerHeight;
  }
}